import React from "react";
import Skeleton, { SkeletonBlock } from "../ui/Skeleton";

/** Readable-register loading placeholder — matches profile card shapes. */
export default function ProfileLoadingSkeleton({
  label = "Loading profile…",
  variant = "cards",
}) {
  if (variant === "page") {
    return (
      <Skeleton label={label} className="space-y-6 pt-2">
        <SkeletonBlock className="h-6 w-40" />
        <SkeletonBlock className="h-9 w-56 max-w-full" />
        <div className="space-y-4">
          <SkeletonBlock className="h-28 rounded-card" />
          <SkeletonBlock className="h-40 rounded-card" />
          <SkeletonBlock className="h-48 rounded-card" />
        </div>
      </Skeleton>
    );
  }

  if (variant === "list") {
    return (
      <Skeleton label={label} className="space-y-2">
        {[1, 2, 3].map((i) => (
          <SkeletonBlock key={i} className="h-[52px]" />
        ))}
      </Skeleton>
    );
  }

  return (
    <Skeleton label={label} className="space-y-4">
      {[1, 2, 3].map((i) => (
        <SkeletonBlock key={i} className="h-32 rounded-card" />
      ))}
    </Skeleton>
  );
}
